import React, { useState } from 'react';

function FormsPage(){
    return(
    <div className="container mt-4">
      <h2><i className="bi bi-file-medical me-2"></i>Forms</h2>
      <div className="row mt-3 g-3">
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Medical History</h5>
              <p className="card-text">Update your medical history form</p>
              <button className="btn btn-primary w-100">Complete Form</button>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Consent Forms</h5>
              <p className="card-text">Review and sign consent documents</p>
              <button className="btn btn-primary w-100">Sign Now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default FormsPage;